// extracted by mini-css-extract-plugin
export default {"body":"TableBody_body__M4Xch","empty":"TableBody_empty__8ULyk"};